export const panamaCostaRicaJungleProgram = {
  programKey: 'panama-i-kostaryka-z-karaibow-w-glab-dzungli',

  /* Podstawowe informacje wspólne dla sticky paska i przyszłego katalogu. */
  title: 'Panama i Kostaryka - Z Karaibów w głąb dżungli',

  /* Dwuczęściowa nazwa wyświetlana w sticky pasku na PC i tablecie. */
  stickyTitle: 'Panama i Kostaryka:',
  stickySubtitle: 'Z Karaibów w głąb dżungli',

  pageUrl:
    'https://coolturystki.pl/wycieczki/panama-i-kostaryka-z-karaibow-w-glab-dzungli',

  /*
   * Dane wykorzystywane przez kartę programu i filtry katalogu.
   */
  catalog: {
    enabled: true,
    image:
      'https://coolturystki.pl/lib/wyfaqa/wycieczka-panama-kostaryka-karaibska-plaza-mv3unemk.webp',
    heroImageFallback:
      'https://coolturystki.pl/lib/wyfaqa/wycieczka-panama-kostaryka-karaibska-plaza-mv3unemk.webp',
    imagePosition: 'center center',
    summary: '',
    destinations: ['Panama i Kostaryka'],
    continent: 'Ameryka Północna',
    categories: [],
    travelStyles: ['Wyjazd objazdowy', 'Egzotyka'],
    catalogPublishedAt: '2026-10-15',
  },

  /* Termin: 10 - 24 kwietnia 2027. */
  tripIds: [27],

  /*
   * Brak priceNote oznacza, że karta automatycznie pokaże pierwszą transzę
   * obliczoną jako 30% aktualnej ceny pobranej z Vakanzy.
   */
  termDetails: {
    '27': {
      pilotId: 'dorota',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Lot grupowy z Warszawy',
          description:
            'Z Warszawy lecimy do Panama City z jedną przesiadką. Wracamy do Warszawy z San José, również z jedną przesiadką.',
        },
        hotel: {
          title: 'Hotele 3★ i 5★ na trasie',
          description:
            'Trzynaście noclegów spędzamy w Panama City, Bocas del Toro, Punta Uva, Sarapiquí i La Fortuna. Nocujemy w pokojach 2-osobowych ze śniadaniami.',
        },
      },
    },
  },
}
